import script from "./MoveSessionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoveSessionModal.vue?vue&type=script&setup=true&lang=ts"

import "./MoveSessionModal.vue?vue&type=style&index=0&id=2e39ba2d&lang=scss"

const __exports__ = script;

export default __exports__